module.exports = __webpack_public_path__ + "img/AUDI-select-plus.ed638418.webp";